import {all, call, put, takeLatest, delay, select} from 'redux-saga/effects';
import actions from "../actions";
import playersListActions from "../reducers/playersList/playersListActions";
import exportEntriesActions from "../reducers/exportEntries/exportEntriesActions";
import registrationFormActions  from "../reducers/registrationForm/registrationFormActions";
import dartopolis from '../DartopolisClient';


const getToken = (state) => state.root.currentToken;
const getInstance = (state) => state.root.currentInstance;
const getCategories = (state) => state.playersList.categories;


export function* submitRegistration(action) {
    yield put({type: registrationFormActions.SUBMIT_REGISTRATION_STARTED});
    try {
        yield call (dartopolis.submitRegFormAsync, action.registration);
        yield put({type: registrationFormActions.SUBMIT_REGISTRATION_SUCCESS});
    } catch (err) {
        console.log(err);
        yield put({type: registrationFormActions.SUBMIT_REGISTRATION_ERROR, err})
    }
}

export function* loadTournamentInstanceWithRetry(action) {
    let retryCount = 0;
    let retrySeconds = 15;
    while (true) { // eslint-disable-line no-constant-condition
        try {
            const instance = yield call(dartopolis.loadInstance_, action.series);
            if (!instance.data || !instance.data.length) {
                // hmm, need to think about this - why would there be a successful call without data?
                return;
            }
            return instance.data;
        } catch (err) {
            retryCount++;
            if (retryCount === 6) {
                retrySeconds = 60;
            } else if (retryCount === 20) {
                retrySeconds = 180;
            }
            yield put({type: 'LOAD_INSTANCE_RETRY', retrySeconds: retrySeconds, errorCount: retryCount})
            for (let i = 1; i <= retrySeconds; i++) {
                yield put({type: 'LOAD_INSTANCE_RETRY', retrySeconds: retrySeconds - i, errorCount: retryCount})
                yield delay(1000);
            }
        }

    }
}

// saga to load the tournament instance
export function* loadTournamentInstance(action) {
    yield put({type: 'LOAD_INSTANCE_STARTED'});
    const data = yield call(loadTournamentInstanceWithRetry, action);
    const storeAction = actions.onInstanceLoaded(data[0]);
    yield put(storeAction);
}

export function* loadExports(action) {
    try {
        yield put({type: exportEntriesActions.EXPORT_LOAD_LIST_STARTED});
        const jwtToken = yield select(getToken);
        const resp = yield call(dartopolis.loadExports, action.instanceId, jwtToken);
        yield put({type: exportEntriesActions.EXPORT_LOAD_LIST_SUCCESS, exports: resp.data});
    } catch (err) {
        yield put({type: exportEntriesActions.EXPORT_LOAD_LIST_ERROR, err});
    }
}

export function* downloadExport(action) {
    try {
        yield put({type: exportEntriesActions.EXPORT_DOWNLOAD_STARTED});
        const jwtToken = yield select(getToken);
        const resp = yield call(dartopolis.downloadExport, action.exportId, jwtToken);
        yield put({type: exportEntriesActions.EXPORT_DOWNLOAD_SUCCESS, exportData: resp.data});
    } catch (err) {
        yield put({type: exportEntriesActions.EXPORT_DOWNLOAD_ERROR, err});
    }
}

export function* generateExport(action) {
    try {
        yield put({type: exportEntriesActions.EXPORT_GENERATE_STARTED});
        const jwtToken = yield select(getToken);
        yield call(dartopolis.generateExport, action.instanceId, jwtToken);
        yield put({type: exportEntriesActions.EXPORT_GENERATE_SUCCESS});
        const resp2 = yield call(dartopolis.loadExports, action.instanceId, jwtToken);
        yield put({type: exportEntriesActions.EXPORT_LOAD_LIST_SUCCESS, exports: resp2.data});
    } catch (err) {
        yield put({type: exportEntriesActions.EXPORT_GENERATE_ERROR, err});
    }
}

export function* deleteExport(action) {
    try {
        yield put({type: exportEntriesActions.EXPORT_DELETE_STARTED});
        const jwtToken = yield select(getToken);
        yield call(dartopolis.deleteExport, action.exportId, jwtToken);
        yield put({type: exportEntriesActions.EXPORT_DELETE_SUCCESS});
        const resp2 = yield call(dartopolis.loadExports, action.instanceId, jwtToken);
        yield put({type: exportEntriesActions.EXPORT_LOAD_LIST_SUCCESS, exports: resp2.data});
    } catch (err) {
        yield put({type: exportEntriesActions.EXPORT_DELETE_ERROR, err});
    }
}

export function* swapPlayers(action) {
    try {
        yield put({type: actions.SWAP_PLAYERS_STARTED});
        const jwtToken = yield select(getToken);
        yield call(dartopolis.swapEntryPlayerOrder, action.regEntryId, jwtToken);
        yield put({type: actions.SWAP_PLAYERS_SUCCESS, entryId: action.regEntryId});
    } catch (err) {
        yield put({type: actions.SWAP_PLAYERS_ERROR, err});
    }
}

export function* deleteRegistrationEntry(action) {
    try {
        yield put({type: actions.DELETE_REGISTRATION_ENTRY_STARTED});
        const jwtToken = yield select(getToken);
        yield call(dartopolis.deleteRegistrationEntry, action.regEntryId, action.deleteEntry, jwtToken);
        yield put({type: actions.DELETE_REGISTRATION_ENTRY_SUCCESS, entryId: action.regEntryId, newDeletedState: action.deleteEntry});
    } catch (err) {
        yield put({type: actions.DELETE_REGISTRATION_ENTRY_ERROR, err});
    }
}

export function* updateRegistrationEntry(action) {
    try {
        yield put({type: actions.UPDATE_REGISTRATION_ENTRY_STARTED});
        const jwtToken = yield select(getToken);
        const resp = yield call(dartopolis.updateRegistrationEntry, action.regEntry, jwtToken);
        yield put({type: actions.UPDATE_REGISTRATION_ENTRY_SUCCESS, entry: resp.data});
    } catch (err) {
        yield put({type: actions.UPDATE_REGISTRATION_ENTRY_ERROR, err});
    }
}

export function* loadCategoryEntries(action) {
    yield put({type: actions.ENTRIES_LOAD_STARTED});
    try {
        const resp = yield call(dartopolis.fetchPlayersAsync, action.categoryId, '', action.includeDeleted);
        const data = resp.data;
        yield put({type: actions.ENTRIES_LOAD_SUCCESS, data: data});
    } catch (err) {
        yield put({type: actions.ENTRIES_LOAD_ERROR, err});
    }
}


export function* loadPlayersList(action) {
    yield put({type: playersListActions.LOAD_CATEGORY_ENTRIES_STARTED});
    let instanceLoaded = false;
    // first ensure that the current tournament instance has already been loaded
    let instance = null;
    while (!instanceLoaded) {
        instance = yield select(getInstance);
        if (instance) {
            instanceLoaded = true;
        } else {
            yield delay(1000);
        }
    }
    let categories = yield select(getCategories);
    if (!categories || categories.length === 0) {
        yield put({type: playersListActions.SET_CATEGORIES, categories: instance.categories})
        categories = instance.categories;
    }
    try {
        const categoryId = action.categoryId ? action.categoryId : categories[0].id;
        const resp = yield call(dartopolis.fetchPlayersAsync, categoryId, '', false);
        const data = resp.data;
        yield put({type: playersListActions.LOAD_CATEGORY_ENTRIES_SUCCESS, entries: data, selectedCategoryId: categoryId});
    } catch (err) {
        yield put({type: playersListActions.LOAD_CATEGORY_ENTRIES_ERROR, err});
    }
}

export function* login(action) {
    yield put({type: actions.LOGIN_STARTED});
    yield delay(250);
    try {
        const resp = yield call(dartopolis.login, action.username, action.password);
        const data = resp.data;
        yield put({type: actions.LOGIN_SUCCESS, token: data.token, username: data.username, fullName: data.fullName});
    } catch (err) {
        yield put({type: actions.LOGIN_ERROR, err});
    }
}

/*
 * Used to apply a simple text-matching search to the list of players already downloaded.
 */
export function* searchPlayers(action) {
    yield delay(500);
    yield put({type: actions.ENTRIES_LOAD_STARTED});
    try {
        const resp = yield call(dartopolis.fetchPlayersAsync, action.categoryId, action.searchText, action.includeDeleted);
        const data = resp.data;
        yield put({type: actions.ENTRIES_LOAD_SUCCESS, data: data});
    } catch (err) {
        yield put({type: actions.ENTRIES_LOAD_ERROR, err});
    }
}

export function* submitRegistrationWatcher() {
    yield takeLatest(registrationFormActions.SUBMIT_REGISTRATION, submitRegistration);
}

export function* searchPlayersWatcher() {
    yield takeLatest(actions.PLAYERS_PAGE_SEARCH, searchPlayers);
}

export function* swapPlayersWatcher() {
    yield takeLatest(actions.SWAP_PLAYERS, swapPlayers);
}

export function* deleteRegistrationEntryWatcher() {
    yield takeLatest(actions.DELETE_REGISTRATION_ENTRY, deleteRegistrationEntry);
}

export function* updateRegistrationEntryWatcher() {
    yield takeLatest(actions.UPDATE_REGISTRATION_ENTRY, updateRegistrationEntry);
}

export function* watcherSaga() {
    yield takeLatest(actions.LOAD_LATEST_INSTANCE, loadTournamentInstance);
}

export function* loginWatcher() {
    yield takeLatest(actions.LOGIN_START, login);
}

export function* fetchPlayersWatcher() {
    yield takeLatest(actions.ENTRIES_LOAD, loadCategoryEntries);
}

export function* loadPlayersListWatcher() {
    yield takeLatest(playersListActions.LOAD_CATEGORY_ENTRIES, loadPlayersList);
}

export function* loadExportsWatcher() {
    yield takeLatest(exportEntriesActions.EXPORT_LOAD_LIST, loadExports);
}

export function* loadExportDownloadWatcher() {
    yield takeLatest(exportEntriesActions.EXPORT_DOWNLOAD, downloadExport);
}

export function* generateExportWatcher() {
    yield takeLatest(exportEntriesActions.EXPORT_GENERATE, generateExport);
}

export function* deleteExportWatcher() {
    yield takeLatest(exportEntriesActions.EXPORT_DELETE, deleteExport);
}

export default function* rootSaga() {
    yield all([
        watcherSaga(),
        loginWatcher(),
        fetchPlayersWatcher(),
        swapPlayersWatcher(),
        deleteRegistrationEntryWatcher(),
        updateRegistrationEntryWatcher(),
        searchPlayersWatcher(),
        loadExportsWatcher(),
        loadExportDownloadWatcher(),
        generateExportWatcher(),
        deleteExportWatcher(),
        loadPlayersListWatcher(),
        submitRegistrationWatcher()
    ]);
}